import React from 'react'


const Api_Url = 'https://covid19.mathdro.id/api';

export default Api_Url;